import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store/store'
import detectDevice from './utils/detectDevice'
import responsiveRender from '@/utils/responsiveRender'

Vue.use(Router)

const router = new Router({
  base: process.env.BASE_URL,
  mode: 'history',
  routes: [
    {
      path: '/loading',
      name: 'loading',
      component: () => import(/* webpackChunkName: 'Loading' */'@/views/Loading/Loading')
    },
    {
      path: '/',
      name: 'home',
      component: () => import(/* webpackChunkName: 'Home' */'@/views/Home/Home')
    },
    {
      path: '/menu',
      name: 'menu',
      component: responsiveRender({
        Mobile: () => import(/* webpackChunkName: 'Menu' */'@/views/Menu/layouts/Mobile/Mobile'),
        Desktop: () => import(/* webpackChunkName: 'Menu' */'@/views/Menu/layouts/Desktop/Desktop')
      })
    },
    {
      path: '/selection',
      name: 'selection',
      component: responsiveRender({
        Mobile: () => import(/* webpackChunkName: 'SelectionMobile' */'@/views/Selection/layouts/Mobile/Mobile'),
        Desktop: () => import(/* webpackChunkName: 'SelectionDesktop' */'@/views/Selection/layouts/Desktop/Desktop')
      }),
      props: true
    },
    {
      path: '/calibration',
      name: 'calibration',
      component: responsiveRender({
        Mobile: () => import(/* webpackChunkName: 'CalibrationMobile' */'@/views/Calibration/layouts/Mobile/Mobile'),
        Desktop: () => import(/* webpackChunkName: 'CalibrationDesktop' */'@/views/Calibration/layouts/Desktop/Desktop')
      })
    },
    {
      path: '/gameplay',
      name: 'gameplay',
      component: () => import(/* webpackChunkName: 'Gameplay' */'@/views/Gameplay/Gameplay')
    },
    {
      path: '/results',
      name: 'results',
      component: () => import(/* webpackChunkName: 'Results' */'@/views/Results/Results')
    },
    {
      path: '/champion',
      name: 'champion',
      component: () => import(/* webpackChunkName: 'Champion' */'@/views/Champion/Champion')
    },
    {
      path: '/share',
      name: 'share',
      component: responsiveRender({
        Mobile: () => import(/* webpackChunkName: 'ShareMobile' */'@/views/Share/layouts/Mobile/Mobile'),
        Desktop: () => import(/* webpackChunkName: 'ShareDesktop' */'@/views/Share/layouts/Desktop/Desktop')
      })
    },
    {
      path: '/instructions',
      name: 'instructions',
      component: () => import(/* webpackChunkName: 'Instructions' */'@/views/Instructions/Instructions'),
      props: true
    },
    {
      path: '/highscores',
      name: 'highscores',
      component: () => import(/* webpackChunkName: 'Highscores' */'@/views/Highscores/Highscores')
    },
    {
      path: '/leaderboard',
      name: 'leaderboard',
      component: responsiveRender({
        Mobile: () => import(/* webpackChunkName: 'LeaderboardMobile' */'@/views/Leaderboard/layouts/Mobile/Mobile'),
        Desktop: () => import(/* webpackChunkName: 'LeaderboardDesktop' */'@/views/Leaderboard/layouts/Desktop/Desktop')
      }),
      props: true
    },
    {
      path: '/login',
      name: 'login',
      component: () => import(/* webpackChunkName: 'Login' */'@/views/Login/Login')
    },
    {
      path: '/optin',
      name: 'optin',
      component: () => import(/* webpackChunkName: 'Optin' */'@/views/Optin/Optin')
    },
    {
      path: '/unsupported',
      name: 'unsupported',
      component: () => import(/* webpackChunkName: 'Unsupported' */'@/views/Unsupported/Unsupported'),
      props: true
    },
    {
      path: '/maintenance',
      name: 'maintenance',
      component: () => import(/* webpackChunkName: 'Maintenance' */'@/views/Maintenance/Maintenance')
    },
    {
      path: '/form',
      name: 'form',
      component: () => import(/* webpackChunkName: 'Form' */'@/views/Form/Form')
    },
    {
      path: '/twitter',
      name: 'twitter'
    },
    {
      path: '/logout',
      name: 'logout',
      redirect: () => {
        store.dispatch('user/logout')
        return '/login'
      }
    },
    {
      path: '*',
      redirect: '/'
    }
  ]
})

let firstLoad = true
router.beforeEach(async (to, _, next) => {
  if (process.env.VUE_APP_ENV === 'maintenance') return next(to.path === '/maintenance' ? undefined : '/maintenance')
  if (firstLoad) {
    firstLoad = false
    const device = detectDevice()
    if (!device.isSupported) return next({ name: 'unsupported', params: { title: device.noSupportTitle, subtitle: device.noSupportSubtitle } })
    if (to.path === '/twitter') { localStorage.setItem('id', to.query.id); return next('/loading') }
    return next('/loading')
  }
  next()
})

export default router
